import { render, staticRenderFns } from "./addHeal.vue?vue&type=template&id=c2c16870&scoped=true"
import script from "./addHeal.vue?vue&type=script&lang=js"
export * from "./addHeal.vue?vue&type=script&lang=js"
import style0 from "./addHeal.vue?vue&type=style&index=0&id=c2c16870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c16870",
  null
  
)

export default component.exports